export type DrawerWidgetState = {
  dismissed: boolean
  minimized: boolean
  manuallyMinimized: boolean
  userOverrodeAuto: boolean
}

export class SessionStorageService {
  private static instance: SessionStorageService | undefined
  private readonly namespace = 'drawer_widget_state'

  public static getInstance(): SessionStorageService {
    if (!this.instance) {
      this.instance = new SessionStorageService()
    }
    return this.instance
  }

  private safeGetStorage(): Storage | undefined {
    try {
      if (typeof window === 'undefined') return undefined
      return window.sessionStorage
    } catch {
      return undefined
    }
  }

  private makeKey(id: string): string {
    return `${this.namespace}_${id}`
  }

  public get<T>(id: string): T | undefined {
    const storage = this.safeGetStorage()
    if (!storage) return undefined

    const raw = storage.getItem(this.makeKey(id))
    if (!raw) return undefined

    try {
      return JSON.parse(raw) as T
    } catch {
      return undefined
    }
  }

  public set<T>(id: string, value: T): void {
    const storage = this.safeGetStorage()
    if (!storage) return

    try {
      storage.setItem(this.makeKey(id), JSON.stringify(value))
    } catch {
      // noop
    }
  }

  public remove(id: string): void {
    const storage = this.safeGetStorage()
    if (!storage) return

    try {
      storage.removeItem(this.makeKey(id))
    } catch {
      // noop
    }
  }
}
